import { render, staticRenderFns } from "./ReportIssueList.vue?vue&type=template&id=3c4eb2e8&scoped=true"
import script from "./ReportIssueList.vue?vue&type=script&lang=js"
export * from "./ReportIssueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4eb2e8",
  null
  
)

export default component.exports